var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7499 2.13879H1.24986C1.15165 2.13879 1.07129 2.21915 1.07129 2.31737V3.74594C1.07129 3.84415 1.15165 3.92451 1.24986 3.92451H18.7499C18.8481 3.92451 18.9284 3.84415 18.9284 3.74594V2.31737C18.9284 2.21915 18.8481 2.13879 18.7499 2.13879ZM18.7499 16.0674H1.24986C1.15165 16.0674 1.07129 16.1477 1.07129 16.2459V17.6745C1.07129 17.7727 1.15165 17.8531 1.24986 17.8531H18.7499C18.8481 17.8531 18.9284 17.7727 18.9284 17.6745V16.2459C18.9284 16.1477 18.8481 16.0674 18.7499 16.0674ZM18.7499 9.10308H1.24986C1.15165 9.10308 1.07129 9.18344 1.07129 9.28165V10.7102C1.07129 10.8084 1.15165 10.8888 1.24986 10.8888H18.7499C18.8481 10.8888 18.9284 10.8084 18.9284 10.7102V9.28165C18.9284 9.18344 18.8481 9.10308 18.7499 9.10308Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/BurgerIcon.fc16b191499a9fc4b78fed2f1510698f.svg";
export { ForwardRef as ReactComponent };